module.exports = __webpack_public_path__ + "static/media/Orca Card Mockup.b1d8ae82.png";